import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AttractorTimeout from '../../warning/attractorTimeout';

const LeaderboardAverage = ({ config, passRefUpward }) => {
    const [latestScore, setLatestScore] = useState(0);
    const [scoreAverage, setScoreAverage] = useState(0);
    const [cluesUsedDisplay, setCluesUsedDisplay] = useState(null);

    useEffect(() => {
        const scoreArr = JSON.parse(window.sessionStorage.getItem('scoreArr')) || [];
        const scoreAvg = scoreArr.length > 0 && Math.floor(scoreArr.reduce((a, b) => a + b) / scoreArr.length);
        setScoreAverage(scoreAvg);
        setLatestScore(window.sessionStorage.getItem('latestScore'));

        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));
        const playData = JSON.parse(window.sessionStorage.getItem('playData'));
        if (sessionData) sessionData.playData.push(playData);
        window.sessionStorage.setItem('sessionData', JSON.stringify(sessionData));

        setCluesUsedDisplay(JSON.parse(window.sessionStorage.getItem('cluesUsed')));
    }, []);

    const exportAndClearData = () => {
        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));

        if (sessionData && sessionData.startTime !== null && window.ipc) {
            const json = {};
            const duration = Date.now() - sessionData.startTime;
            const minutes = Math.floor(duration / 60000);
            const seconds = ((duration % 60000) / 1000).toFixed(0);
            json.duration = Number(seconds) === 60 ? (minutes+1) + ":00" : minutes + ":" + (seconds < 10 ? "0" : "") + seconds;

            json.playCount = sessionData.playData.length;
            json.playData = sessionData.playData;

            window.ipc.sendSync('session-data-send', json);
        }

        window.sessionStorage.setItem('sessionData', JSON.stringify({
            startTime: null,
            playData: []
        }));
    };

    AttractorTimeout(config, passRefUpward);

    return (
        <div className={`leaderboard-average ${cluesUsedDisplay ? 'extra-info': ''}`}>
            <div className='leaderboard-average__internal'>
                <div className="leaderboard-average__info">
                    <div className="leaderboard-average__info-text-block">
                        <img src="./img/icon-skillstrength.svg" alt="" className="leaderboard-average__info-text-block-icon" />
                        <h1>{config.screens.leaderboardScreen.block_title}</h1>
                        {config.screens.leaderboardScreen.text_block.map((text, idx) => <text.element key={idx}>{text.text}</text.element>)}
                    </div>

                    <div className='App__button play-again'>
                        <div className='App__button-large-container'>
                            <button onClick={exportAndClearData}>
                                <Link to={`${config.screens.leaderboardScreen.play_again_button_link}`}>
                                    {config.screens.leaderboardScreen.play_again_button_text}
                                </Link>
                            </button>
                            <span> </span> {/* Decorative span */}
                            <span> </span> {/* Decorative span */}
                        </div>
                    </div>
                </div>

                <div className='leaderboard-average__score'>
                    <div className='leaderboard-average__score-your-score'>
                        <span>{config.screens.leaderboardScreen.you_scored}</span> {latestScore}
                    </div>
                    <div className='leaderboard-average__score-average'>
                        <span>{config.screens.leaderboardScreen.today_average}</span> {scoreAverage}
                    </div>
                    {cluesUsedDisplay && (
                        <div className='leaderboard-average__clues'>
                            <h3>How did you do?</h3>
                            {cluesUsedDisplay.map(clue =>
                                <div
                                    className='leaderboard-average__clues-clue'
                                    key={clue.question}
                                >
                                    <span>Q{clue.question + 1}.</span>
                                    <span className={clue.cluesUsed === 1 ? 'singular' : ''}>
                                        {clue.cluesUsed} {clue.cluesUsed === 1 ? 'clue' : 'clues'}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LeaderboardAverage;
